<template>
    <div class="hero">
        <div class="cover">
            <div class="coverArtwork loadEffect"></div>
            <div class="avatar"></div>
            <div class="content">
                <div class="userDetails">
                    <div class="skeletonHeading skeletonShort loadEffect"></div>
                </div>
            </div>
        </div>

        <div class="intro">
            <div class="skeletonDescription skeletonFull loadEffect"></div>
            <div class="skeletonDescription skeletonFull loadEffect"></div>
            <div class="skeletonDescription skeletonFull loadEffect"></div>
            <div class="skeletonDescription skeletonShort loadEffect"></div>
        </div>

        <div class="blurredCover loadEffect">
            <div class="blurredCoverImage "></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HeroSkeleton'
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .hero {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    .avatar {
        margin: 0 2rem -4rem 0;
        width: 8rem;
        height: 8rem;
        z-index: 1;
        display: block;
        object-fit: cover;
        background: var(--color-grey-200);
        border-radius: 50%;
        box-shadow: var(--shadow-l);
    }

    .cover {
        position: relative;
        display: flex;
        align-items: flex-end;
        height: 20rem;
        width: 100%;
        padding: 1.5rem 1.5rem 2rem 4rem;

        &::after {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            bottom: 0;
            left: 0;
            background: var(--gradient-black-0-black-60-important);
            border-radius: 0 0 1rem 1rem;
        }
    }

    .coverArtwork {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 1rem;
    }

    .blurredCover {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        z-index: -2;

        &::after {
            content: '';
            position: absolute;
            width: 100%;
            height: 90%;
            top: 0;
            left: 0;
            background: var(--gradient-black-1-black-0);
        }
    }

    .content {
        display: flex;
        z-index: 1;
        flex: 1;
    }

    .userDetails {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        color: var(--color-white-important);
        z-index: 1;
    }

    .intro {
        max-width: 56rem;
        padding: 2rem 2rem 4rem 14rem;
    }

    .skeletonDescription {
        margin-bottom: 1rem;
    }

    @media all and (max-width: 1440px) {
        .cover {
            padding-left: 2rem;
        }

        .intro {
            padding-left: 12rem;
        }
    }

    @media all and (max-width: 640px) {
        .cover {
            flex-direction: column;
            align-items: center;
            justify-content: flex-end;
            padding: 2rem 1rem;
        }

        .content {
            margin: 0;
            width: 100%;
            height: auto;
            flex: 0;
        }

        .userDetails {
            justify-content: center;
        }

        .avatar {
            margin: 0 0 2rem 0;
            width: 6rem;
            height: 6rem;
        }

        .socials {
            margin-bottom: 1rem;

            .social {
                &:first-of-type {
                    margin: 0;
                }
            }
        }

        .intro {
            padding: 2rem 1rem 3rem 1rem;
            align-items: center;
        }
    }
</style>
